import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddresscurrentComponent } from './addresscurrent/addresscurrent.component';
import { AddresspreviousComponent } from './addressprevious/addressprevious.component';
import { CandidateDetailsComponent } from './candidatedetails/candidatedetails.component';
import { CandidateinviteComponent } from './candidateinvite/candidateinvite.component';
import { PackageDetailsComponent } from './package-details/package-details.component';
import { OrderModalComponent } from './order-modal/order-modal.component';

import {
    FadvComponentsModule,
    FadvStepperModule,
    FadvAlertModule,
    FadvApplicationModule,
    FadvBoxModule,
    FadvButtonModule,
    FadvCardModule,
    FadvGridModule,
    FadvLayoutModule,
    FadvTypographyModule,
    FadvCommonModule,
    FadvModalModule,
    FadvCheckboxCardModule
  } from '@fa-switch-sharedservices/ng-elements';
import { SignedConsentModalComponent } from './signed-consent-modal/signed-consent-modal.component';
import { UserModalComponent } from './user-modal/user-modal.component';
import { ALaCarteProductComponent } from './ala-carte-product/ala-carte-product.component';
import { EmploymentComponent } from './employment/employment.component';
import { EducationComponent } from './education/education.component';
import { PaymentExtendedComponent } from './payment-extended/payment-extended.component';


  @NgModule({
    declarations: [ 
      AddresscurrentComponent, 
      AddresspreviousComponent, 
      CandidateDetailsComponent, 
      CandidateinviteComponent, 
      PackageDetailsComponent, 
      OrderModalComponent, 
      SignedConsentModalComponent,
      UserModalComponent,
      ALaCarteProductComponent,
      EmploymentComponent,
      EducationComponent,
      PaymentExtendedComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FadvComponentsModule,
        FadvCardModule,
        FadvStepperModule,
        FadvCommonModule,
        FadvApplicationModule,
        FadvAlertModule,
        FadvLayoutModule,
        FadvGridModule,
        FadvButtonModule,
        FadvBoxModule,
        FadvTypographyModule,
        FadvModalModule,
        FadvCheckboxCardModule
    ],
    exports: [
      AddresscurrentComponent, 
      AddresspreviousComponent, 
      CandidateDetailsComponent, 
      CandidateinviteComponent, 
      PackageDetailsComponent,
      OrderModalComponent,
      SignedConsentModalComponent,
      UserModalComponent,
      ALaCarteProductComponent,
      EmploymentComponent,
      EducationComponent,
      PaymentExtendedComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
  })

export class SharedModule {}
